export const getCapitalizedFirstLetter = (str) => str.charAt(0).toUpperCase();

export const getUserInitials = (name, lastName) => `${getCapitalizedFirstLetter(name)}${getCapitalizedFirstLetter(lastName)}`;
